import { useApplicationConfig } from '@bonusly/application';

import { useURLBuilder } from './use-url-builder';

export const useBuildMonarchURL = () => {
	const base = useApplicationConfig('monarchOrigin');
	return useURLBuilder(base);
};
